import { KeyboardManager } from './useKeyboardManager';

export const useKeyActiveCursor = (keyboardManager?: KeyboardManager) => {
  if (keyboardManager?.space) {
    return 'grab';
  }
};
